var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_7558",
    "data-name": "\\uADF8\\uB8F9 7558",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.596,
    height: 16.299,
    viewBox: "0 0 24.596 16.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8707",
    "data-name": "\\uC0AC\\uAC01\\uD615 8707",
    width: 24.596,
    height: 16.299,
    fill: "#8c8c8c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7557",
    "data-name": "\\uADF8\\uB8F9 7557",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12520",
    "data-name": "\\uD328\\uC2A4 12520",
    d: "M32.861,15.557H31.149a.445.445,0,1,1,0-.889h1.712a.215.215,0,0,0,.215-.215V9.345a.212.212,0,0,0-.023-.1L30.871,5.005a.213.213,0,0,0-.191-.116H23.889V15.113a.445.445,0,1,1-.889,0V4.445A.445.445,0,0,1,23.445,4h7.236a1.1,1.1,0,0,1,.981.6l2.18,4.241a1.1,1.1,0,0,1,.122.5v5.108a1.1,1.1,0,0,1-1.1,1.1",
    transform: "translate(-9.368 -1.629)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12521",
    "data-name": "\\uD328\\uC2A4 12521",
    d: "M33.339,11.445H27.445A.445.445,0,0,1,27,11V7.445A.445.445,0,0,1,27.445,7h4.129a.445.445,0,0,1,.4.247L33.738,10.8a.445.445,0,0,1-.4.642m-5.45-.889h4.733L31.3,7.889H27.889Z",
    transform: "translate(-10.998 -2.851)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12522",
    "data-name": "\\uD328\\uC2A4 12522",
    d: "M21.335,22.889h-8.89a.445.445,0,0,1,0-.889h8.89a.445.445,0,1,1,0,.889",
    transform: "translate(-4.888 -8.961)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12523",
    "data-name": "\\uD328\\uC2A4 12523",
    d: "M2.815,13.928H.445A.445.445,0,0,1,0,13.483V1.4A1.4,1.4,0,0,1,1.4,0H13.121a1.4,1.4,0,0,1,1.4,1.4V3.8a.445.445,0,1,1-.889,0V1.4a.511.511,0,0,0-.51-.51H1.4a.511.511,0,0,0-.51.51v11.64H2.815a.445.445,0,1,1,0,.889",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12524",
    "data-name": "\\uD328\\uC2A4 12524",
    d: "M19.371,18.889H13.445a.445.445,0,0,1,0-.889h5.927a.445.445,0,1,1,0,.889",
    transform: "translate(-5.295 -7.332)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12525",
    "data-name": "\\uD328\\uC2A4 12525",
    d: "M1.63,18.889H.445a.445.445,0,0,1,0-.889H1.63a.445.445,0,0,1,0,.889",
    transform: "translate(0 -7.332)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12526",
    "data-name": "\\uD328\\uC2A4 12526",
    d: "M6.815,23.63A2.815,2.815,0,1,1,9.63,20.815,2.819,2.819,0,0,1,6.815,23.63m0-4.741a1.926,1.926,0,1,0,1.926,1.926,1.928,1.928,0,0,0-1.926-1.926",
    transform: "translate(-1.629 -7.332)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12527",
    "data-name": "\\uD328\\uC2A4 12527",
    d: "M30.815,23.63a2.815,2.815,0,1,1,2.815-2.815,2.819,2.819,0,0,1-2.815,2.815m0-4.741a1.926,1.926,0,1,0,1.926,1.926,1.928,1.928,0,0,0-1.926-1.926",
    transform: "translate(-11.405 -7.332)",
    fill: "#8c8c8c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelivery);
export default __webpack_public_path__ + "static/media/icon_delivery.ddea5e5efd1244d6ed131616bce99208.svg";
export { ForwardRef as ReactComponent };